import { gql } from '@apollo/client';

/**
 * ТЗ 0122 — почтовый клиент ERP. Общие наборы полей — фрагментами (по имени,
 * без `${…}`: интерполяцию codegen молча пропускает).
 */

export const MailMailboxFieldsFragment = gql`
  fragment MailMailboxFields on MailMailboxType {
    id
    email
    displayName
    kind
    canSend
    colorIndex
    inboxUnread
    inboxTotal
    draftsCount
    scheduledCount
    importStatus
    lastSyncAt
    pushActive
    historyFrom
    backfillStatus
    backfillProgress
  }
`;

export const MailLabelFieldsFragment = gql`
  fragment MailLabelFields on MailLabelType {
    id
    mailboxId
    gmailLabelId
    name
    type
    colorBg
    colorText
    unread
    total
  }
`;

export const MailThreadItemFieldsFragment = gql`
  fragment MailThreadItemFields on MailThreadListItemType {
    id
    mailboxId
    mailboxEmail
    subject
    snippet
    lastMessageAt
    messageCount
    unreadCount
    participants {
      email
      name
    }
    labelIds
    isStarred
    isInInbox
    hasAttachments
    snoozedUntil
    hasDraft
    insight {
      category
      priority
      needsReply
      deadline
    }
  }
`;

export const MailMessageFieldsFragment = gql`
  fragment MailMessageFields on MailMessageType {
    id
    gmailId
    rfcMessageId
    inReplyToId
    from {
      email
      name
    }
    to {
      email
      name
    }
    cc {
      email
      name
    }
    bcc {
      email
      name
    }
    replyTo {
      email
      name
    }
    subject
    snippet
    sentAt
    isOurs
    sentByName
    isUnread
    isDraft
    bodyLoaded
    bodyHtml
    bodyText
    attachments {
      index
      name
      mime
      size
      inline
    }
  }
`;

export const MailDraftFieldsFragment = gql`
  fragment MailDraftFields on MailDraftType {
    id
    gmailDraftId
    mailboxId
    threadId
    replyToMessageId
    subject
    to {
      email
      name
    }
    cc {
      email
      name
    }
    bcc {
      email
      name
    }
    html
    text
    attachments {
      index
      name
      mime
      size
      inline
    }
    updatedAt
  }
`;

export const MailContactFieldsFragment = gql`
  fragment MailContactFields on MailContactType {
    id
    email
    name
    kind
    lastContactAt
    messagesCount
    linked {
      kind
      id
      title
    }
  }
`;

/** ТЗ 0122, «ИИ в почте»: разбор треда. */
export const MailInsightFieldsFragment = gql`
  fragment MailInsightFields on MailInsightType {
    category
    priority
    needsReply
    sentiment
    summary
    threadSummary
    questions
    action
    actionReason
    deadline
    snoozeUntil
    task {
      title
      description
      priority
      dueDate
    }
    suggestedLabelIds
    basedOnMessageId
    createdAt
    stale
  }
`;

/** ТЗ 0122, «ИИ в почте»: черновик ответа с источниками. */
export const MailAiReplyFieldsFragment = gql`
  fragment MailAiReplyFields on MailAiReplyType {
    suggestionId
    html
    text
    language
    cached
    citations {
      kind
      ref
      label
    }
    missingInfo
    answeredQuestions
    confidence
  }
`;
